module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABZElEQVRIS+2VYVFDMRCEdxUUFFAHgALAQVEADgAFpQoAB+AAB7QKwAHFASg45utc3ryWlzb8hpvJzEvm3t5mb5NYGxER15LuNtd3zGe2b/s5HgCeSxpLWjaCkzuyvd8CPN9kUCsSETCd2l4jWWP8V4Ej4lTSSep4mY2jiS3Bv4ziioXt+Urj0oAWlIaclfVqwFgHG70mUOfTiGD9mVGckztmbSSpCvwk6VHSmyTkOCQ5v18knWVRChBXko4lIeF0G/B5agbwXp5CgGGEjpxMxmf2YmJ7EhGQoE+DjD9sjyOC6vwI+Hsyvk/2kwSmGDtjR6zxDzEI/CAJgAsybM8iAqZFFqQoATDB9vsxCMwWj3rVmaMlkgBO0RKwJQrTruA2VzS4qpqyxhhWpcuwgl1htKsIjJEOtxBL28v/S6iTrSbFwS9fkHHrRV9uun7jbnIy9B5+2caSWxnXHtPyBhb3/DgU/YVvdzLHF/qtRjQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-icon.png
// module id = 05GT
// module chunks = 3